import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';

export default function Invoice({ orderData, markup }) {


  console.log('orderData pdf : ', orderData)
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header Section */}
        <View style={styles.section}>
          <View style={styles.headerRow}>
            <Image src="/assets/logo-1.png" style={styles.logo} />
            <View style={styles.invoiceDetails}>
              <Text style={styles.textDefault}>Invoice No: <Text style={styles.textPrimary}>{orderData?.reference}</Text></Text>
              <Text style={styles.textDefault}>Created Date: {formatDate(orderData?.creationDate)}</Text>
              <Text style={styles.textDefault}>Client Reference: {orderData?.clientReference}</Text>
            </View>
          </View>
        </View>

        {/* Customer & Company Details */}
        <View style={[styles.section, { marginBottom: '100px' }]}>
          <View style={styles.headerRow}>
            <View>
              <Text style={styles.textDefault}>Supplier: {orderData?.supplier?.name}</Text>
              <Text style={styles.textDefault}>VAT Number: {orderData?.supplier?.vatNumber}</Text>
            </View>
            <View>
              <Text style={styles.textDefault}>Holder: {orderData?.holder.name} {orderData?.holder.surname}</Text>
            </View>
          </View>
        </View>

        {/* Product Table */}
        <View style={styles.section}>
          <View style={styles.table}>
            <View style={[styles.tableRow, styles.tableHeader]}>
              <Text style={styles.tableCell}>Hotel</Text>
              <Text style={styles.tableCell}>Check In - Out</Text>
              <Text style={styles.tableCell}>Room</Text>
              <Text style={styles.tableCell}>Price</Text>
              <Text style={styles.tableCell}>Total</Text>
            </View>
            <View style={styles.tableRow}>
              <Text style={styles.tableCell}>{orderData?.hotel.name}</Text>
              <Text style={styles.tableCell}>{formatDate(orderData?.hotel.checkIn)} - {formatDate(orderData?.hotel.checkOut)}</Text>
              <Text style={styles.tableCell}>{orderData?.hotel.rooms[0].name}</Text>
              <Text style={styles.tableCell}>{(Number(orderData?.totalNet) + Number((orderData?.totalNet) % markup)).toFixed(2)} {orderData?.currency}</Text>
              <Text style={styles.tableCell}>{(Number(orderData?.totalNet) + Number((orderData?.totalNet) % markup)).toFixed(2)} {orderData?.currency}</Text>
            </View>
          </View>
        </View>

        {/* Footer */}
        <View style={styles.footer}>
          <Text>Payment Type: {orderData?.hotel.rooms[0].paymentType}</Text>
          <Text>Cancellation Policy: {orderData?.hotel?.rooms?.[0]?.cancellationPolicies?.[0]?.amount} {orderData?.currency} if canceled after {formatDate(orderData?.hotel?.rooms?.[0]?.cancellationPolicies?.[0]?.from)}</Text>
          <Text>Remarks: {orderData?.remark}</Text>
        </View>
      </Page>
    </Document>
  );
}

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontFamily: 'Helvetica',
    flexDirection: 'column',
    height: '100%',
  },
  section: {
    marginBottom: 20,
    paddingBottom: 10,
    borderBottom: '1px solid #ccc',
  },
  headerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  logo: {
    width: 200,
    height: 50,
  },
  invoiceDetails: {
    textAlign: 'right',
  },
  textDefault: {
    fontSize: 10,
    color: '#333',
  },
  textPrimary: {
    color: '#007bff',
    fontWeight: 'bold',
  },
  table: {
    display: 'table',
    width: '100%',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#ddd',
    marginBottom: 10,
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableHeader: {
    backgroundColor: '#f8f9fa',
    fontWeight: 'bold',
    fontSize: 10,
  },
  tableCell: {
    padding: 5,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#ddd',
    flex: 1,
    fontSize: 10,
  },
  footer: {
    marginTop: 'auto',
    textAlign: 'center',
    fontSize: 10,
  },
});
